import React, { useState } from 'react';
import ExemptedReview from './ExemptedReview';
import NinetyDayReviewForm from './NinetyDaysForm';
import PersonalInfoChange from './PersonalInfoChange';
import { SideNavTabs } from '../../Components/Common/DashboardKit';

/**
 * Web Forms vertical sub-tabs (HR021 exempt review / 90-day review /
 * HR020 PIC form).
 *
 * Pass 5 UI update (2026): hand-rolled 220px sidebar replaced with
 * SideNavTabs from the DashboardKit. Same visuals, same active state.
 */
const DocIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
);

const UserIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

const TABS = [
    { id: '1', label: 'HR021 — Exempt review form', icon: <DocIcon />,      content: <ExemptedReview /> },
    { id: '2', label: '90-day review form',         icon: <CalendarIcon />, content: <NinetyDayReviewForm /> },
    { id: '3', label: 'HR020 — PIC form',           icon: <UserIcon />,     content: <PersonalInfoChange /> },
];

const WebFormsTimelineTabs = () => {
    const [active, setActive] = useState('1');
    const current = TABS.find(tab => tab.id === active);

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 16, alignItems: 'start' }}>
            <SideNavTabs
                tabs={TABS.map(t => ({ key: t.id, label: t.label, icon: t.icon }))}
                activeKey={active}
                onChange={setActive}
                width={220}
                ariaLabel="Web forms sections"
            />

            <div style={{ background: 'var(--ssw-surface, #fff)', border: '0.5px solid var(--ssw-line, #e2e2e2)', borderRadius: 12, padding: '1.25rem', minHeight: 400 }}>
                {current?.content}
            </div>
        </div>
    );
};

export default WebFormsTimelineTabs;
